var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14L13.5 5M12 13.25C12 13.4489 12.079 13.6397 12.2197 13.7803C12.3603 13.921 12.5511 14 12.75 14C12.9489 14 13.1397 13.921 13.2803 13.7803C13.421 13.6397 13.5 13.4489 13.5 13.25C13.5 13.0511 13.421 12.8603 13.2803 12.7197C13.1397 12.579 12.9489 12.5 12.75 12.5C12.5511 12.5 12.3603 12.579 12.2197 12.7197C12.079 12.8603 12 13.0511 12 13.25ZM4.5 5.75C4.5 5.94891 4.57902 6.13968 4.71967 6.28033C4.86032 6.42098 5.05109 6.5 5.25 6.5C5.44891 6.5 5.63968 6.42098 5.78033 6.28033C5.92098 6.13968 6 5.94891 6 5.75C6 5.55109 5.92098 5.36032 5.78033 5.21967C5.63968 5.07902 5.44891 5 5.25 5C5.05109 5 4.86032 5.07902 4.71967 5.21967C4.57902 5.36032 4.5 5.55109 4.5 5.75Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerPercentage);
export default __webpack_public_path__ + "static/media/tabler_percentage.d28998e1b6e2fbc6652a867f6e1089e1.svg";
export { ForwardRef as ReactComponent };